const $ = jQuery.noConflict();

'use strict';
const Timeline = {

	$domTimeline: $('.js-timeline'),
	$domTimelineBox: $('.js-timeline__box'),

	init: function() {
		this.openShape();
	},

	openShape: () => {
		if(Timeline.$domTimeline.length) {

			$(window).on('scroll', function() {

				const currenttScroll = $(window).scrollTop();

				const arr = [];

				Timeline.$domTimelineBox.each(function() {
					const itemHeight = $(this).offset().top - 400;
					arr.push(itemHeight);
				});

				const closest = arr.reduce((a, b) => {
					return Math.abs(b - currenttScroll) < Math.abs(a - currenttScroll) ? b : a;
				});

				Timeline.$domTimelineBox.each(function() {
					const itemHeight = $(this).offset().top - 400;

					if(closest === itemHeight) {
						$(this).find('.timeline__txt-box').stop().slideDown();
					}
				});
			});
		}
	},
};
export default Timeline;